import { Helmet } from 'react-helmet';
import PageHeader from './Common/PageHeader';
const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Understand and read our privacy policy for new customers </title>
        <meta
          name="keywords"
          content="creative items,unique items,creative items to sell,creative craft items,creative gift items,creative home decor products,unique home accessories,best home decor gifts,unique kitchen decor,unique modern home decor,unique decorative items,unique house accessories,cheap home decor gifts,unique kitchen products,unique kitchenware itemsunique kitchen items,home and kitchen unique products,unique kitchen accessories,unique kitchen tools"
        />
        <meta
          name="description"
          content="Our privacy policy puts customers first so we never leak any of your data to third-party clients. At Bakumia, we keep your data only for suggestion purposes"
        />
      </Helmet>
      <PageHeader title="Privacy Policy" />
      <section className="policy-section py-3">
        <div className="container-fluid">
          <div className="text-center mb-5">
            <h2 className="fw-semibold">Privacy Policy</h2>
            <div className="policy-divider"></div>
            <p className="text-muted mt-3">
              We are committed to protecting the privacy of our valued customers
              and ensuring the safety of your personal data.
            </p>
          </div>

          <div className="policy-card mb-4">
            <h5 className="fw-bold mb-3">Overview</h5>
            <p>
              Bakumia.pk is operated by Bakumia, and this Privacy Policy applies
              to your use of our website. By using our site, you agree to how we
              collect, use, and protect your personal data.
            </p>
            <p>
              Our website is fully secured and encrypted, ensuring that your
              purchases and personal details are safe. You can confidently shop
              our wide range of unique home accessories.
            </p>
          </div>

          <div className="policy-card mb-4">
            <h5 className="fw-bold mb-3">Use of Personal Data</h5>
            <p>
              We collect your name, address, phone number, email, and date of
              birth solely for delivering products and maintaining order
              records.
            </p>
            <p>
              Your data may be used to send brand updates or promotional offers
              via email or SMS. We store your data only as long as necessary to
              provide our services, after which it is permanently deleted.
            </p>
          </div>

          <div className="policy-card mb-4">
            <h5 className="fw-bold mb-3">
              Sharing Information with Third Parties
            </h5>
            <p>
              We only share personal information with trusted third parties who
              perform services on our behalf to complete transactions.
            </p>
            <p>
              Your personal details will never be sold, reused, or disclosed to
              unaffiliated third parties.
            </p>
          </div>

          <div className="policy-card mb-4">
            <h5 className="fw-bold mb-3">Your Rights</h5>
            <p>
              You have the right to access any personal information we hold
              about you. If you believe your data is incorrect or irrelevant,
              you can request corrections or deletion.
            </p>
          </div>

          <div className="policy-card mb-4">
            <h5 className="fw-bold mb-3">Cookies</h5>
            <p>
              We do not have a cookie policy and do not store any cookies in
              your system.
            </p>
          </div>

          <div className="policy-card">
            <h5 className="fw-bold mb-3">Third-Party Cookies</h5>
            <p>
              Since we do not use cookies, no third-party cookies are used on
              the Bakumia website.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};
export default PrivacyPolicy;
